export default "__VITE_ASSET__Dzt491sq__"